import type { FC, ReactNode, ElementType } from 'react';
import PropTypes from 'prop-types';
import { Box, Grid, ListItem, ListItemText, Typography } from '@material-ui/core';
import type { ListItemProps } from '@material-ui/core';

interface PropertyListItemProps extends ListItemProps {
  align?: string;
  children?: ReactNode;
  component?: ElementType;
  label: string;
  value?: string;
}

export const PropertyListItem: FC<PropertyListItemProps> = (props) => {
  const { align, children, component, value, label, ...other } = props;

  return (
    <ListItem
      component={component}
      disableGutters
      sx={{
        py: 0.5
      }}
      {...other}
    >
      <ListItemText
        disableTypography
        primary={(
          <Grid
            item
            xs={8}
            pr={1}
          >
            <Typography
              color="textPrimary"
              variant="subtitle2"
            >
              {label}
            </Typography>
          </Grid>
        )}
        secondary={(
          <Grid
            item
            xs={12}
            pr={1}
          >
            <Box
              sx={{
                flex: 1,
                mt: align === 'vertical' ? 0.5 : 0
              }}
            >
              {children || (
              <Typography
                color="textSecondary"
                variant="body2"
              >
                {value}
              </Typography>
              )}
            </Box>
          </Grid>
        )}
        sx={{
          alignItems: 'flex-start',
          display: 'flex',
          flexDirection: align === 'vertical' ? 'column' : 'row',
          my: 0
        }}
      />
    </ListItem>
  );
};

PropertyListItem.defaultProps = {
  align: 'vertical'
};

PropertyListItem.propTypes = {
  align: PropTypes.string,
  // @ts-ignore
  component: PropTypes.elementType,
  children: PropTypes.node,
  label: PropTypes.string.isRequired,
  value: PropTypes.string
};
